import { Box, Divider, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

import { Button } from '@/components/Button';
import { ReviewIcon } from '@/components/Icons';
import { Dialog, DialogContent, dialogClasses } from '@/components/Dialog';
import { REVIEW_PAGE } from './constants';

export function LeaveReviewAlert({ open, onClose }) {
	const { t } = useTranslation();

	return (
		<Dialog
			onClose={(event, reason) => {
				if (reason === 'backdropClick') {
					return;
				}
				onClose?.(event, reason);
			}}
			open={open}
			hasCross
			sx={{
				[`.${dialogClasses.paper}`]: {
					overflow: 'hidden',
					width: { xs: '100%', md: '388px' },
					margin: { xs: '0px', md: '0px auto' },
					bottom: { xs: '0px', md: 'unset' },
					position: { xs: 'fixed', md: 'relative' }
				}
			}}
		>
			<DialogContent
				sx={{
					display: 'flex',
					flexDirection: 'column',
					gap: '24px',
					padding: '48px 24px 24px 24px',
					width: { xs: '100%', lg: '388px' }
				}}
			>
				<Box
					sx={theme => ({
						backgroundColor: theme.palette.neutral[150],
						color: theme.palette.primary.main,
						borderRadius: '8px',
						width: '40px',
						height: '40px',
						display: 'flex',
						alignItems: 'center',
						justifyContent: 'center'
					})}
				>
					<ReviewIcon />
				</Box>
				<Box>
					<Typography fontWeight={700} variant="body3">
						{t('myImages.leaveReviewDialog.title')}
					</Typography>
					<Typography
						sx={theme => ({
							width: '65%',

							[theme.breakpoints.down('md')]: {
								width: 'auto'
							}
						})}
						variant="body1"
					>
						{t('myImages.leaveReviewDialog.description')}
					</Typography>
				</Box>
				<Divider />
				<Box
					display="flex"
					gap={1}
					flexDirection={{ xs: 'column-reverse', md: 'row' }}
				>
					<Button
						target="_blank"
						rel="noopener noreferrer"
						onClick={onClose}
						variant="outlined"
						sx={{ width: '100%' }}
					>
						{t('common.cancel')}
					</Button>
					<Button
						href={REVIEW_PAGE}
						target="_blank"
						rel="noopener noreferrer"
						onClick={onClose}
						variant="contained"
						sx={{ width: '100%' }}
					>
						{t('myImages.leaveReviewDialog.buttonLabel')}
					</Button>
				</Box>
			</DialogContent>
		</Dialog>
	);
}
